import { useFeatureFlags } from './flags';

/**
 * Who may see a distributor's access package, and who may change it.
 *
 * Two flags, both the legacy admin's by name and by meaning
 * (`SettingsSubform.tsx`): `viewAccessPackage` decides whether the package
 * appears at all, `adminAccessPackageRights` decides whether the Change control
 * appears beside it. They are deliberately separate — seeing which tier a
 * distributor is on is not the same right as moving it between tiers.
 *
 * Neither is the integration flag. The access package and the integration guard
 * are unrelated concerns that happened to sit on the same legacy screen.
 */
export interface AccessPackageAccess {
  /** `viewAccessPackage`: is the package shown at all. */
  canView: boolean;
  /** `adminAccessPackageRights`: may this person move it between tiers. */
  canChange: boolean;
}

/** The flag someone has to ask for to change a package. */
export const ACCESS_PACKAGE_FLAG = 'adminAccessPackageRights' as const;

export const useAccessPackageAccess = (): AccessPackageAccess => {
  const flags = useFeatureFlags();

  return {
    canView: flags.viewAccessPackage,
    canChange: flags[ACCESS_PACKAGE_FLAG],
  };
};
